module.exports = __webpack_public_path__ + "static/media/remember_01.ce488ffe.png";